module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _c('div', [_c('fieldset', [_vm._m(0), _vm._v(" "), (_vm.preferences.length > 0) ? _c('div', {
    staticClass: "col-sm-6"
  }, _vm._l((_vm.middleIndex), function(index) {
    return _c('div', {
      key: index - 1,
      staticClass: "checkbox c-checkbox"
    }, [(_vm.isGeneralPreference(index - 1)) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.preferences[index - 1].isSelected),
        expression: "preferences[index - 1].isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.preferences[index - 1].id,
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": _vm.preferences[index - 1].id,
        "checked": Array.isArray(_vm.preferences[index - 1].isSelected) ? _vm._i(_vm.preferences[index - 1].isSelected, _vm.preferences[index - 1].id) > -1 : (_vm.preferences[index - 1].isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = _vm.preferences[index - 1].isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.preferences[index - 1].id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.preferences[index - 1].isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.preferences[index - 1].isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.preferences[index - 1].isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n            Where Calvert Impact Capital sees the most need and opportunity\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isGeneralPreference(index - 1) && !_vm.isOtherPreference(index - 1)) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.preferences[index - 1].isSelected),
        expression: "preferences[index - 1].isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.preferences[index - 1].id,
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": _vm.preferences[index - 1].id,
        "checked": Array.isArray(_vm.preferences[index - 1].isSelected) ? _vm._i(_vm.preferences[index - 1].isSelected, _vm.preferences[index - 1].id) > -1 : (_vm.preferences[index - 1].isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = _vm.preferences[index - 1].isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.preferences[index - 1].id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.preferences[index - 1].isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.preferences[index - 1].isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.preferences[index - 1].isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n            " + _vm._s(_vm.preferences[index - 1].preferenceText) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isGeneralPreference(index - 1) && !_vm.isOtherPreference(index - 1)) ? _c('a', {
      staticClass: "checkbox-link",
      attrs: {
        "href": _vm.preferences[index - 1].url,
        "target": "_blank",
        "rel": "noopener",
        "aria-describedby": "new-window",
        "title": "Read more..."
      }
    }, [_c('em', {
      staticClass: "fa fa-external-link",
      attrs: {
        "aria-hidden": ""
      }
    })]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.preferences.length > 0) ? _c('div', {
    staticClass: "col-sm-6"
  }, _vm._l(((_vm.preferences.length - _vm.middleIndex)), function(index) {
    return _c('div', {
      key: index + _vm.middleIndex - 1,
      staticClass: "checkbox c-checkbox"
    }, [(_vm.isGeneralPreference(index + _vm.middleIndex - 1)) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.preferences[index - 1].isSelected),
        expression: "preferences[index - 1].isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.preferences[index - 1].id,
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": _vm.preferences[index - 1].id,
        "checked": Array.isArray(_vm.preferences[index - 1].isSelected) ? _vm._i(_vm.preferences[index - 1].isSelected, _vm.preferences[index - 1].id) > -1 : (_vm.preferences[index - 1].isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = _vm.preferences[index - 1].isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.preferences[index - 1].id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.preferences[index - 1].isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.preferences[index - 1].isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.preferences[index - 1].isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n            Where Calvert Impact Capital sees the most need and opportunity\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isGeneralPreference(index + _vm.middleIndex - 1) && !_vm.isOtherPreference(index + _vm.middleIndex - 1)) ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.preferences[(index + _vm.middleIndex) - 1].isSelected),
        expression: "preferences[(index + middleIndex) - 1].isSelected"
      }],
      attrs: {
        "type": "checkbox",
        "id": _vm.preferences[(index + _vm.middleIndex) - 1].id,
        "disabled": _vm.isReadOnly
      },
      domProps: {
        "value": _vm.preferences[(index + _vm.middleIndex) - 1].id,
        "checked": Array.isArray(_vm.preferences[(index + _vm.middleIndex) - 1].isSelected) ? _vm._i(_vm.preferences[(index + _vm.middleIndex) - 1].isSelected, _vm.preferences[(index + _vm.middleIndex) - 1].id) > -1 : (_vm.preferences[(index + _vm.middleIndex) - 1].isSelected)
      },
      on: {
        "change": _vm.onChangeSelectImpactPreference,
        "__c": function($event) {
          var $$a = _vm.preferences[(index + _vm.middleIndex) - 1].isSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = _vm.preferences[(index + _vm.middleIndex) - 1].id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.preferences[(index + _vm.middleIndex) - 1].isSelected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.preferences[(index + _vm.middleIndex) - 1].isSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.preferences[(index + _vm.middleIndex) - 1].isSelected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "fa fa-check"
    }), _vm._v("\n            " + _vm._s(_vm.preferences[(index + _vm.middleIndex) - 1].preferenceText) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.isGeneralPreference(index + _vm.middleIndex - 1) && !_vm.isOtherPreference(index + _vm.middleIndex - 1)) ? _c('a', {
      staticClass: "checkbox-link",
      attrs: {
        "href": _vm.preferences[index + _vm.middleIndex - 1].url,
        "target": "_blank",
        "rel": "noopener",
        "aria-describedby": "new-window",
        "title": "Read more..."
      }
    }, [_c('em', {
      staticClass: "fa fa-external-link",
      attrs: {
        "aria-hidden": ""
      }
    })]) : _vm._e()])
  })) : _vm._e()]), _vm._v(" "), _c('fieldset', {
    staticClass: "extra-option"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('RestrictedSingleInput', {
    attrs: {
      "dual": true,
      "input": _vm.other,
      "limit": 50,
      "warningLimit": 29,
      "fieldLabel": "Other",
      "instructionsLabel": "Make sure your text doesn't exceed 50 characters.",
      "placeholderText": 'Enter your preference here...',
      "isDisabled": _vm.isReadOnly
    },
    on: {
      "inputUpdated": _vm.selectOtherPreference
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-lg button-submit",
    attrs: {
      "type": "submit",
      "disabled": _vm.isReadOnly
    },
    on: {
      "click": _vm.showConfirmationModal
    }
  }, [_vm._v("Submit")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "hidden": ""
    }
  }, [_c('span', {
    attrs: {
      "id": "new-window"
    }
  }, [_vm._v("Read more about it. This link opens in a new window.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e9ef906","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preferences.vue
// module id = 2146
// module chunks = 1